import React, { useEffect, useState } from 'react';
import { useLiceos } from '../../../application/liceos/hooks/useLiceos';
import ToolbarComponent from '../../ui/section';
import DynamicTable from '../../ui/table2';
import Loader from '../../ui/loader';
import { ModalConfirm } from '../../ui/modal2';
import FloatingButton from '../../ui/floatButton';
import { IconButton } from '../../ui/button';

const LiceosPage = (props) => {
    const {
        getLiceos,
        deleteLiceo,
        isLoading,
        error
    } = useLiceos();

    const [liceos, setLiceos] = useState([]);
    const [removeModal, setRemoveModal] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const columns = [
        { key: 'name', label: 'Nombre', style: { width: "25%" } },
        { key: 'address', label: 'Dirección', style: { width: "25%" } },
        { key: 'region', label: 'Región', style: { width: "15%" } },
        { key: 'city', label: 'Ciudad', style: { width: "15%" } },
        { key: 'status', label: 'Estado', style: { width: "10%" } },
        { key: 'actions', label: 'Acciones' }
    ];

    const customElements = {
        status: (data) => {
            const statusColors = {
                active: '#10B981',
                inactive: '#6B7280'
            };
            const statusLabels = {
                active: 'Activo',
                inactive: 'Inactivo'
            };
            return (
                <span style={{ 
                    color: statusColors[data.status] || '#6B7280',
                    fontWeight: 600
                }}>
                    {statusLabels[data.status] || data.status}
                </span>
            );
        },
        actions: (data) => (
            <div style={{ display: 'flex', gap: '8px' }}>
                <IconButton onClick={() => handleView(data.id || data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.58 12C15.58 13.98 13.98 15.58 12 15.58C10.02 15.58 8.42004 13.98 8.42004 12C8.42004 10.02 10.02 8.42004 12 8.42004C13.98 8.42004 15.58 10.02 15.58 12Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 20.27C15.53 20.27 18.82 18.19 21.11 14.59C22.01 13.18 22.01 10.81 21.11 9.39997C18.82 5.79997 15.53 3.71997 12 3.71997C8.46997 3.71997 5.17997 5.79997 2.88997 9.39997C1.98997 10.81 1.98997 13.18 2.88997 14.59C5.17997 18.19 8.46997 20.27 12 20.27Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
                <IconButton onClick={() => handleEdit(data.id || data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16.04 3.02001L8.16 10.9C7.86 11.2 7.56 11.79 7.5 12.22L7.07 15.23C6.91 16.32 7.68 17.08 8.77 16.93L11.78 16.5C12.2 16.44 12.79 16.14 13.1 15.84L20.98 7.96001C22.34 6.60001 22.98 5.02001 20.98 3.02001C18.98 1.02001 17.4 1.66001 16.04 3.02001Z" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.91 4.1499C15.58 6.5399 17.45 8.4099 19.85 9.0899" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
                <IconButton onClick={() => handleDelete(data.id || data._id)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10.33 16.5H13.66" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.5 12.5H14.5" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </IconButton>
            </div>
        )
    };

    useEffect(() => {
        loadLiceos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadLiceos = async () => {
        try {
            const data = await getLiceos({ page: 1, limit: 100 });
            setLiceos(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error('Error al cargar liceos:', err);
        }
    };

    const handleView = (id) => {
        props.history.push(`/academia/liceos/${id}`);
    };

    const handleEdit = (id) => {
        props.history.push(`/academia/liceos/${id}/edit`);
    };

    const handleDelete = (id) => {
        setCurrentId(id);
        setRemoveModal(true);
    };

    const handleRemoveConfirm = async () => {
        if (currentId) {
            try {
                await deleteLiceo(currentId);
                await loadLiceos();
                setRemoveModal(false);
                setCurrentId(null);
            } catch (err) {
                console.error('Error al eliminar liceo:', err);
            }
        }
    };

    const handleNew = () => {
        props.history.push('/academia/liceos/new');
    };

    return (
        <>
            <ToolbarComponent label="Liceos" showBackButton={false}>
                {error && (
                    <div style={{ padding: '10px', background: '#FEE2E2', color: '#DC2626', borderRadius: '4px', marginBottom: '16px' }}>
                        {error}
                    </div>
                )}
                <DynamicTable
                    headers={columns}
                    data={liceos}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando liceos" />}
                    isLoading={isLoading}
                />
                <FloatingButton position="bottom-right" onClick={handleNew} />
            </ToolbarComponent>
            <ModalConfirm 
                isOpen={removeModal} 
                onClose={() => setRemoveModal(false)} 
                onAccept={handleRemoveConfirm}
                title="¿Eliminar liceo?"
                message="Esta acción no se puede deshacer."
            />
        </>
    );
};

export default LiceosPage;









